var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologySmartWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -638.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Smart-watch",
    transform: "translate(3880.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12.75 C20,12.336 19.664,12 19.25,12 L17.75,12 C17.336,12 17,12.336 17,12.75 L17,14.25 C17,14.664 17.336,15 17.75,15 L19.25,15 C19.664,15 20,14.664 20,14.25 L20,12.75 Z M20,17.75 C20,17.336 19.664,17 19.25,17 L17.75,17 C17.336,17 17,17.336 17,17.75 L17,19.25 C17,19.664 17.336,20 17.75,20 L19.25,20 C19.664,20 20,19.664 20,19.25 L20,17.75 Z M15,12.75 C15,12.336 14.664,12 14.25,12 L12.75,12 C12.336,12 12,12.336 12,12.75 L12,14.25 C12,14.664 12.336,15 12.75,15 L14.25,15 C14.664,15 15,14.664 15,14.25 L15,12.75 Z M24,12 L24,20 C24,22.209 22.209,24 20,24 L12,24 C9.791,24 8,22.209 8,20 L8,12 C8,9.791 9.791,8 12,8 L20,8 C22.209,8 24,9.791 24,12 L24,12 Z M12,6 L20,6 C20.659,6 21.291,6.111 21.885,6.308 C19,4 20.742,0 19.205,0 L12.783,0 C11.245,0 13,4 10.101,6.313 C10.699,6.113 11.336,6 12,6 L12,6 Z M21.885,25.692 C19,28 20.742,32 19.205,32 L12.783,32 C11.245,32 13,28 10.101,25.688 C10.699,25.887 11.336,26 12,26 L20,26 C20.659,26 21.291,25.89 21.885,25.692 L21.885,25.692 Z",
    id: 131
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologySmartWatch);
export default __webpack_public_path__ + "static/media/device-and-technology-smart-watch.3d40d1e5.svg";
export { ForwardRef as ReactComponent };